import { useSelector } from "react-redux";
import PageTitle from "../components/common/PageTitle";
import { useAppContext } from "../providers/ProviderAppContainer";
import { useCallback, useEffect, useState } from "react";
import Loading from "../components/common/Loading";
import NoContent from "../components/common/NoContent";
import { Outlet } from "react-router-dom";
import PromoDialog from "../components/common/PromoDialog";

export default function ChaptersTest() {
    const loggedInUser = useSelector((state) => state.stateUser);
    const { requestAPI } = useAppContext();

    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const [promoDialogContents, setPromoDialogContents] = useState();

    const [testCatalogue, setTestCatalogue] = useState();
    const [testSelection, setTestSelection] = useState();
    const [testResult, setTestResult] = useState();

    useEffect(() => {
        requestAPI({
            requestPath: `users/${loggedInUser?.id}/chapters-test-catalogue`,
            requestMethod: "GET",
            setLoading: setLoading,
            onRequestStart: setError,
            onRequestFailure: setError,
            onResponseReceieved: (testCatalogue, responseCode) => {
                if (testCatalogue && responseCode === 200) {
                    setTestCatalogue(testCatalogue);
                } else {
                    setError("Couldn't load Test Catalogue");
                }
            },
        });
    }, [loggedInUser?.id, requestAPI]);

    useEffect(() => {
        requestAPI({
            requestPath: "dialog-contents/chapters-test",
            requestMethod: "GET",
            onResponseReceieved: (contents, code) => {
                if (code === 200 && Array.isArray(contents)) {
                    setPromoDialogContents(contents);
                }
            },
        });
    }, [requestAPI]);

    const onContentSeen = useCallback(
        (content_id) => {
            requestAPI({
                requestPath: "dialog-contents/views/chapters-test",
                requestMethod: "POST",
                requestPostBody: { content_id },
                parseResponseBody: false,
                onResponseReceieved: (_, code) => {
                    if (code === 204) {
                        setPromoDialogContents((prev) => {
                            const slide = prev?.find((c) => c.id === content_id);
                            if (!slide || slide.viewed) return prev;
                            return prev.map((c) => (c.id === content_id ? { ...c, viewed: true } : c));
                        });
                    }
                },
            });
        },
        [requestAPI],
    );

    return (
        <div className="flex flex-column gap-2 h-full overflow-hidden">
            <PageTitle title={`Self Test`} />

            {loading ? (
                <Loading message={"Loading Test Catelogue"} />
            ) : error ? (
                <NoContent error={"Failed To Load Test Catelogue"} />
            ) : (
                <div className="flex-1 min-h-0 overflow-y-scroll overflow-x-hidden">
                    <Outlet context={{ testCatalogue, testSelection, setTestSelection, testResult, setTestResult }} />
                </div>
            )}

            <PromoDialog contents={promoDialogContents} onContentSeen={onContentSeen} />
        </div>
    );
}
